module.exports = __webpack_public_path__ + "static/media/a8aeea1b-1a9d-45b7-8ad9-7c71824599e2.65a7a2f9.woff";